// Labels for an org discount rule's scope. Keep in step with PricingRule_Save's
// @scope guard and DiagnosticLines_Get's @discountScope branches.
// "additional" is the State Farm rule.
export const SCOPE_LABELS = {
  all: 'All line items',
  additional: 'All ADAS-L calibrations except the most expensive line'
}

export const scopeLabel = (scope) => SCOPE_LABELS[scope] || scope
